import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig() || {};

export const googleApiKey = publicRuntimeConfig?.NEXT_PUBLIC_GOOGLE_MAPS_API;
